import { StringUtil } from "@eres/core";
import { FormFieldProps } from "../../index";
import { getHolder, isViewError } from "../../Utils";

export const DisableEditOrgDataProvider = ( props: FormFieldProps<any, any> ) => {

	if ( isViewError( props ) ) return false;
	let { id } = props as any;
	const holder = getHolder( props );
	const forceEdit = holder.readValue( "forceEdit" );
	if ( forceEdit && forceEdit.hasOwnProperty( id ) ) {
		if ( forceEdit[ id ] === true )
			return false;
	}
	let orgData = holder.readValue( "orgData" ) as any;
	if ( orgData && orgData.hasOwnProperty( id ) ) {
		const val = orgData[ id ];
		if ( typeof ( val ) === "string" ) {
			return !StringUtil.isEmptyStringOrNull( val );
		} else if ( val != null ) {
			return true;
		}
	}
	return false;
};
